export const getFileInfo = (fileObject) => {
  const { name } = fileObject
  const lastDot = name.lastIndexOf('.')

  const fileName = name.substring(0, lastDot)
  const ext = name.substring(lastDot + 1)

  return {
    name: fileName,
    type: ext,
    sizeInMB: fileObject.size / 1024000,
  }
}
